import { KoobNotFound } from '@koob/ui';
import KoobLayout from '../components/Koob/KoobLayout';

export default function NotFound() {
  return (
    <KoobLayout>
      <KoobNotFound />
    </KoobLayout>
  );
}
